<template>
  <div id="OilFuchsproducts">
    <div class="container-fluid px-3 py-3 bg">
    <br>
    <br>
    <br>
    <br>
    <br>
    <br>
      <h1 class="text-light">OIL AND GREASE</h1>
      <br>
      <h3 class="text-light">Choose with Your Needs</h3>
      <div class="row row-cols-1 row-cols-md-3 g-4">
        <template v-for="(ct, key) in content">
          <div :class="{ active: key }" :key="key">
            <div class="col">
              <div class="card h-100">
                <img :src="ct.Oiltype" class="card-img-top" />
                <div class="card-body">
                  <h5 class="card-title">{{ ct.Oiltypename }}</h5>
                  <p class="card-text">{{ ct.Text }}</p>
                </div>
              </div>
            </div>
          </div>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "OilProd",

  data: () => ({
    content: [
      {
        Oiltype: "img/Oil_Products/Cassida_Fluid_GL_220.png",
        Oiltypename: "Cassida Fluid GL 220",
        Text: "Synthetic gear lubricants for use in food manufacturing equipment.",
      },
      {
        Oiltype: "img/Oil_Products/Cassida_Fluid_GL_220.png",
        Oiltypename: "Cassida Fluid HF 32",
        Text: "Synthetic hydraulic fluids for food manufacturing machinery.",
      },
      {
        Oiltype: "img/Oil_Products/Cassida_Fluid_GL_220.png",
        Oiltypename: "Cassida Grease EPS 2",
        Text:
          "Synthetic extreme pressure greases for food and beverage processing equipment.",
      },
      {
        Oiltype: "img/Oil_Products/Cassida_Fluid_GL_220.png",
        Oiltypename: "Cassida Grease GTS 2",
        Text:
          "Specialty synthetic extreme pressure grease for food and beverage processing equipment.",
      },
      {
        Oiltype: "img/Oil_Products/Titan_Universal_HD_15W40.png",
        Oiltypename: "Renolin B10 VG 32",
        Text:
          "Lubrication and hydraulic oils with additives to improve the ageing and oxidation stability.",
      },
      {
        Oiltype: "img/Oil_Products/Titan_Universal_HD_15W40.png",
        Oiltypename: "Renolin B15 VG 46",
        Text: "For good wear protection in stationary and mobile hydraulic systems",
      },
      {
        Oiltype: "img/Oil_Products/Titan_Universal_HD_15W40.png",
        Oiltypename: "Renolin B20 VG 68",
        Text: "Universal applicable hydraulic fluids if good ageing resistance.",
      },
      {
        Oiltype: "img/Oil_Products/Titan_Universal_HD_15W40.png",
        Oiltypename: "Renolin CLP 150",
        Text: "High-performance gear and circulating oils with good ageing stability.",
      },
      {
        Oiltype: "img/Oil_Products/Titan_Universal_HD_15W40.png",
        Oiltypename: "Renolin CLP 220",
        Text: "Speciality For good EP performance and excellent corrosion protection..",
      },
      {
        Oiltype: "img/Oil_Products/Titan_Universal_HD_15W40.png",
        Oiltypename: "Renolit CXI 2",
        Text:
          "Calcium sulphonat complex grease with particularly good working stability, speciality in salt waters.",
      },
      {
        Oiltype: "img/Oil_Products/Titan_Universal_HD_15W40.png",
        Oiltypename: "Supergear GL5 80W-90",
        Text:
          "a mineral universal gear oil for use in manual transmissions and axle gearboxes.",
      },
      {
        Oiltype: "img/Oil_Products/Titan_Universal_HD_15W40.png",
        Oiltypename: "Titan Gear GL5 90",
        Text:
          "High Performance Gear Oil for highly-stressed differentials in commercial vehicles.",
      },
      {
        Oiltype: "img/Oil_Products/Titan_Universal_HD_15W40.png",
        Oiltypename: "Titan Universal CF 40",
        Text:
          "High Performance Engine Oil for mixed fleets operated under normal conditions.",
      },
      {
        Oiltype: "img/Oil_Products/Titan_Universal_HD_15W40.png",
        Oiltypename: "Titan Universal HD 15W40",
        Text: "Good performance in normally aspirated and turbocharged diesel engines.",
      },
    ],
  }),
};
</script>
<style>
#OilFuchsproducts .card .card-text {
  font-size: 12px;
},
.bg {
  background: #1F1F1F;
}
</style>
